import { ChatEntity } from './entity';
import { omit } from 'lodash';
import { toLuxon } from '@app/api';
import { DateTime } from 'luxon';
import { ChatUser } from './user';

export class ChatMessage extends ChatEntity {
  override type = 'message';
  time = 0;
  medias: any[] = [];
  user: any;
  data: any;
  removed: any;
  removedTime: any;
  replyTo: ChatMessage | null = null;

  constructor(data: any) {
    super(data);

    this.update(data);
  }

  update(data: any) {
    Object.assign(
      this,
      omit(data, ['replyTo', 'type', 'created', 'createdTime']),
    );

    if (data.user) {
      this.user = new ChatUser(data.user);
    }

    if (data.replyTo) {
      this.replyTo = new ChatMessage(data.replyTo);
    }

    if (data.removed) {
      this.removed = toLuxon(data.removed) || DateTime.now();
      this.removedTime = this.removed.toMillis();
    }
  }

  isSameUser(user: any) {
    return this.user?.metas.find(
      (meta: any) => meta.key == 'userId' && meta.value == user?.id,
    );
  }
}
